import { useState } from 'react';
import { DismissButton, LoadingIndicator } from '../../lib/iprs-react-library/src/index.js';
import useRotaTypeToggle from './useRotaTypeToggle';
import userLoggedInHasRole from '../Util/userLoggedInHasRole';
import Notice from '../Util/Notice';

/**
 * Quick-access overlay, opened from the task icon next to a team group's
 * name in the sidebar, listing every task type (RotaType) and letting a
 * Diary Manager toggle it Included/Excluded for just this one group.
 * Shares its include/exclude logic with Settings/RotaTypeGroupSettings.jsx
 * via useRotaTypeToggle.
 */
const TeamGroupTasksOverlay = ({ api, groupID, groupTitle, onClose }) => {

    const hasDiaryManagerPerm = userLoggedInHasRole(api, 'Diary Manager');

    const [notice, setNotice] = useState(null); // { text, isError }, cleared by the next action

    const { rotaTypes, savingRotaTypeID, isIncluded, toggleTask } = useRotaTypeToggle(api, setNotice);

    return <>
        <div className='settings-overlay-backdrop' onClick={onClose} />
        <section className='settings-overlay'>
            <h3>{groupTitle} Task Types</h3>
            <Notice notice={notice} onDismiss={() => setNotice(null)} />
            <ul className='settings-list'>
                {rotaTypes.map(rt => {
                    const included = isIncluded(rt, groupID);
                    const saving = savingRotaTypeID === rt.RotaTypeID;
                    return (
                        <li key={rt.RotaTypeID}>
                            <span className='settings-list__label'>{rt.Description}</span>
                            {saving && <LoadingIndicator loading={true} size={16} />}
                            <button type='button'
                                className={'settings-table__toggle ' +
                                    (included ? 'settings-table__toggle--included' : '')}
                                disabled={!hasDiaryManagerPerm || saving}
                                title={hasDiaryManagerPerm
                                    ? `Click to ${included ? 'exclude from' : 'include for'} ${groupTitle}`
                                    : undefined}
                                onClick={() => toggleTask(rt, groupID)} >
                                {included ? 'Included' : 'Excluded'}
                            </button>
                        </li>
                    );
                })}
                {0 === rotaTypes.length &&
                    <li><span className='settings-list__label'>No task types found.</span></li>
                }
            </ul>
            <DismissButton onClick={onClose} />
        </section>
    </>;
};

export default TeamGroupTasksOverlay;
